import { GROUP_KEYS, FREE_GROUP_KEYS } from 'getting-started-shared-tasks/gettingStartedGroupKeys';
import { ONBOARDING_CMS_SIMPLIFIED, ONBOARDING_CMS_FREE } from 'getting-started-shared-tasks/onboardingKeys';
import { ONBOARDING_VIEWS } from 'user-context/onboardingSettings';
import { CMS_HUB_INTEREST, CMS_SIGNUP_BUSINESS_INTENT } from '../constants/surveyConstants'; // @ts-expect-error ts-migrate(7016) FIXME: This will be migrated in the next phase

import { isUngatedFor } from '../utils/authUtils'; // @ts-expect-error ts-migrate(7016) FIXME: This will be migrated in the next phase

import { HubletUrl } from '../utils/urls';
import { EN } from '../constants/localeConstants';
import { CRM_SIGNUP, CMS_FREE_SIGNUP } from '../constants/signupConstants';
import { getAiOnboardingExperimentRedirectPath } from '../experiments/csfe013';
const CMS_ONBOARDING_HUB_DEMO = 'CMS_ONBOARDING:HUB_DEMO';
const cmsExperiencesChecks = [{
  redirectPath: portalId => {
    return getAiOnboardingExperimentRedirectPath(portalId);
  },
  checks: [{
    signupType: CMS_FREE_SIGNUP,
    survey: {
      cmsSignupIntent: CMS_SIGNUP_BUSINESS_INTENT
    },
    locale: EN
  }]
}, {
  redirectPath: (portalId, auth) => {
    return {
      url: isUngatedFor(auth, CMS_ONBOARDING_HUB_DEMO) ? `${HubletUrl.getAppUrl()}/cms-onboarding-demo/${portalId}/start` : `${HubletUrl.getAppUrl()}/user-guide/${portalId}`,
      view: ONBOARDING_VIEWS.CMS,
      onboardingKey: ONBOARDING_CMS_SIMPLIFIED,
      groupKey: GROUP_KEYS.cmsV3
    };
  },
  checks: [{
    signupType: CMS_FREE_SIGNUP
  }]
}, // As Hub Interest is auto-filled for non-CRM Signup Types, this check goes
// last as it will prematurely match more specific checks above.
{
  redirectPath: (portalId, auth) => {
    return {
      url: isUngatedFor(auth, CMS_ONBOARDING_HUB_DEMO) ? `${HubletUrl.getAppUrl()}/cms-onboarding-demo/${portalId}/start` : `${HubletUrl.getAppUrl()}/user-guide/${portalId}`,
      view: ONBOARDING_VIEWS.CMS,
      onboardingKey: ONBOARDING_CMS_FREE,
      groupKey: FREE_GROUP_KEYS.freeCmsView
    };
  },
  checks: [{
    signupType: CRM_SIGNUP,
    survey: {
      hubInterest: CMS_HUB_INTEREST
    }
  }]
}];
export default cmsExperiencesChecks;